declare global {
  interface Window {
    __env__?: Record<string, string>
  }
}

function getEnv(key: string, fallback = ''): string {
  return window.__env__?.[key] ?? fallback
}

export const config = {
  apiUrl: getEnv('API_URL', 'http://localhost:5000/api/v1'),
  // Firebase web app config: the staff project (diibs-staff-staging for localhost)
  firebaseApiKey: getEnv('FIREBASE_API_KEY'),
  firebaseAuthDomain: getEnv('FIREBASE_AUTH_DOMAIN'),
  firebaseProjectId: getEnv('FIREBASE_PROJECT_ID'),
  firebaseAppId: getEnv('FIREBASE_APP_ID'),
  googleMapApiKey: getEnv('GOOGLE_MAP_API_KEY'),
  stripePublishableKey: getEnv('STRIPE_PUBLISHABLE_KEY'),
  useFirebaseAuth: getEnv('USE_FIREBASE_AUTH', 'false') === 'true',
  chatBiEnabled: getEnv('CHATBI_ENABLED', 'true'),
  themeApiUrl: getEnv('THEME_API_URL'),
  layoutConfigKey: getEnv('LAYOUT_CONFIG_KEY', 'LayoutConfig'),
  i18nConfigKey: getEnv('I18N_CONFIG_KEY', 'i18nConfig'),
  previewDocsUrl: getEnv('PREVIEW_DOCS_URL'),
  version: getEnv('VERSION', '1.0.0'),
  purchaseUrl: getEnv('PURCHASE_URL'),
}
